<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-02 19:59:18
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-12 14:04:19
 * @Description: 鲸鱼资讯
 -->

<template>
  <div class="news-wrapper">
    <div class="main">
      <h2>鲸鱼资讯</h2>
      <div class="news-box">
        <template v-for="(item, index) in newsList">
          <router-link
            class="news-item"
            :key="index"
            v-if="index < 2"
            :to="`/m-about-us/m-news/m-content/${item.trendid}`"
          >
            <div class="img-box">
              <img :src="item.photo1" alt="" srcset="" />
            </div>
            <div class="text-box">
              <h4 class="title">{{ item.title }}</h4>
              <p class="date">{{ item.u_time }}</p>
              <p class="m-content" v-line-clamp:24="3">
                {{ item.summary }}
              </p>
            </div>
          </router-link>
        </template>
        <!-- <div class="news-item">
          <div class="img-box"></div>
          <div class="text-box">
            <h4 class="title">鲸鱼联合宜宾商业银行存管上线</h4>
            <p class="date">2019-03-10</p>
            <p class="m-content" v-line-clamp:24="3">
              近日，鲸鱼联合宜宾商业银行存管上线鲸鱼联合宜宾商业银行存管上线鲸鱼联合宜宾商业银行存鲸鱼联合宜宾商业银行存管上线管上线鲸银行宜宾商业银行存线商业银行存线商业银行存线商业银行存线
            </p>
          </div>
        </div> -->
      </div>
      <div class="main-footer">
        <router-link class="more-news" to="/m-about-us/m-announcement/m-list">更多 > </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'news',
  data() {
    return {
      newsList: [],
      loading: false
    };
  },
  created() {
    this.requestList();
  },
  methods: {
    async requestList() {
      this.loading = true;
      try {
        const res = await this.$http.post('cg/commonRequest', {
          method: 'pinfo.trend.list',
          token: ''
        });
        if (res.code === 200) {
          this.newsList = res.data.list.splice(0, 2);
          // this.newsList = res.data.list;
          this.newsList.forEach(x => {
            x.u_time = x.u_time.split(' ')[0];
          });
          this.loading = false;
        } else {
          this.$message.error(res.msg);
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.news-wrapper {
  background: #fff;
  .main {
    position: relative;
    h2 {
      font-family: 'PingFangSC-Medium';
      font-size: 0.32rem;
      color: #333333;
      text-align: center;
      padding: 0.67rem 0 0.3rem;
    }
    .news-box {
      // display: flex;
      // justify-content: space-around;
      // align-items: center;
      .news-item {
        width: 6.89rem;
        padding: 0.4rem 0;
        margin: 0 auto;
        display: flex;
        cursor: pointer;
        border-top: 0.01rem solid #e6e6e6;
        .img-box {
          width: 1.9rem;
          height: 1.66rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .m-content {
          width: 4.73rem;
          height: 0.68rem;
          text-align: left;
          flex: 1;
          font-family: 'PingFangSC-Regular';
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          font-size: 0.24rem;
          color: #696969;
          line-height: 0.34rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2 !important;
          -webkit-box-orient: vertical;
          margin: 0.16rem 0 0;
        }
        .text-box {
          background: #fff;
          box-sizing: border-box;
          margin-left: 0.4rem;
          flex: 1;
          .title {
            position: relative;
            width: 4.73rem;
            font-family: 'PingFangSC-Medium';
            font-size: 0.24rem;
            color: #333333;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            -webkit-line-clamp: 1;
            &::before {
              content: '';
              position: absolute;
              width: 0.04rem;
              height: 100%;
              background: #2c6eff;
              left: -0.2rem;
              top: 0;
            }
          }
          .date {
            font-size: 0.14rem;
            text-align: left;
            color: #696969;
          }
        }
      }
    }
    .main-footer {
      position: absolute;
      top: 0.71rem;
      right: 0.43rem;
    }
    .more-news {
      display: inline-block;
      font-size: 0.24rem;
      color: #666666;
      text-align: center;
    }
  }
}
</style>
